import React, { useEffect, useState } from 'react';
import './express-help.scss';
import { IPollData, IResultType } from './express-help.types';
import { Col, DatePicker, Form, Input, Modal, notification, Row, Space, Table } from 'antd';
import Button from 'mixins/ui/button/button';
import Link from 'antd/es/typography/Link';
import ResultTypeModal from './modals/modal-resultType';
import {
    deleteResultTypeById,
    getResultTypeList,
    searchResultType,
} from '/react4xp/parts/express-help/actions';

const ResultTypeComponent: React.FC = () => {
    const [data, setData] = useState<IPollData[]>([]);
    const [editMode, setEditMode] = useState<boolean>(false);
    const [isBeingDeleted, setIsBeingDeleted] = useState<boolean>(false);
    const [selectedObject, setSelectedObject] = useState<IResultType>();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState(false);

    const [form] = Form.useForm();
    const { confirm } = Modal;

    const load = () => {
        setIsLoading(true);

        getResultTypeList()
            .then((response) => {
                setData(response.data);
            })
            .finally(() => setIsLoading(false));
    };

    const deleteOne = (id: number) => {
        confirm({
            title: 'Подтвердите действия удаления данных',
            onOk() {
                setIsBeingDeleted(true);
                deleteResultTypeById(id)
                    .then(() => {
                        notification['success']({
                            message: 'Данные успешно удалены!',
                        });
                        load();
                    })
                    .catch(() => {
                        notification['error']({
                            message: 'Ошибка',
                            description: 'Невозможно удалить запись', // JSON.stringify(error),
                        });
                    })
                    .finally(() => setIsBeingDeleted(null));
            },
        });
    };

    const edit = (doc: any) => {
        setIsModalOpen(true);
        setEditMode(true);
        setSelectedObject(doc);
    };

    const add = () => {
        setIsModalOpen(true);
        setEditMode(false);
        setSelectedObject(selectedObject);
    };

    const handleOk = () => {
        setSelectedObject(selectedObject);
        setIsModalOpen(false);
        setEditMode(false);
        load();
    };

    const handleCancel = () => {
        setSelectedObject(selectedObject);
        setEditMode(false);
        setIsModalOpen(false);
    };

    const onActionClick = (key: string, doc: any) => {
        switch (key) {
            case 'EDIT':
                edit(doc);
                break;
            case 'DELETE':
                deleteOne(doc.id);
                break;
        }
    };

    const columns = [
        {
            title: 'ИД',
            dataIndex: 'externalResultTypeId',
        },
        {
            title: 'Результат на казахском языке',
            dataIndex: 'resultTypeKk',
        },
        {
            title: 'Результат на русском языке',
            dataIndex: 'resultTypeRu',
        },
        {
            title: 'Результат на английском языке',
            dataIndex: 'resultTypeEn',
        },
        {
            title: 'Изменил',
            dataIndex: 'username',
        },
        {
            title: 'Действия',
            width: 180,
            render: (text, record) => (
                <span>
                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('DELETE', record);
                        }}
                    >
                        Удалить
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('EDIT', record);
                        }}
                    >
                        Редактировать
                    </Link>
                </span>
            ),
        },
    ];

    useEffect(() => {
        load();
    }, []);

    const onFinish = (values) => {
        searchResultType(values).then((response) => {
            setData(response.data.content);
        });
    };

    const clear = () => {
        form.resetFields();
    };

    return (
        <div className="poll-screen">
            <h4 className="my-3">Типы результатов</h4>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                className="my-3"
            >
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="username"
                            label="Изменил"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="dateFrom"
                            label="Дата изменения C"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="dateTo"
                            label="По"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="resultType"
                            label="Тип результатов на русском"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                </Row>

                <Space wrap>
                    <Button onClick={clear}>Сброс</Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        color="gold"
                    >
                        Поиск
                    </Button>
                </Space>
            </Form>

            <Row
                gutter={{ xs: 24, md: 24 }}
                className="my-3"
                justify="space-between"
            >
                <Col>
                    <h4 className="poll-screen-list">Список типов результатов</h4>
                </Col>
                <Col>
                    <Button
                        color="gold"
                        onClick={add}
                    >
                        Создать тип результата
                    </Button>
                </Col>
            </Row>

            <Table
                className="my-3"
                dataSource={data}
                columns={columns}
                loading={isLoading}
                scroll={{
                    x: true,
                }}
            />

            <ResultTypeModal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                editMode={editMode}
                selectedObject={selectedObject}
            />
        </div>
    );
};

export default ResultTypeComponent;
